import React, { useEffect, useState } from 'react';

import Header from './components/Header.jsx';
import Hero from './sections/Hero.jsx';
import Status from './sections/Status.jsx';
import Connect from './sections/Connect.jsx';
import Store from './sections/Store.jsx';
import Footer from './sections/Footer.jsx';
import AuthPage from './sections/AuthPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import TopupPage from './pages/TopupPage.jsx';
import logo from './assets/westcounty-mark.png';
import { content } from './config/site.js';

export default function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('westcounty-lang') || 'id');
  const [loading, setLoading] = useState(true);
  const [loaderHidden, setLoaderHidden] = useState(false);

  useEffect(() => {
    localStorage.setItem('westcounty-lang', lang);
  }, [lang]);

  useEffect(() => {
    const readyTimer = window.setTimeout(() => setLoading(false), 950);
    const removeTimer = window.setTimeout(() => setLoaderHidden(true), 1450);

    return () => {
      window.clearTimeout(readyTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll('.reveal');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, [lang, loading]);

  const safeLang = content[lang] ? lang : 'id';
  const loaderText = content[safeLang].loader;
  const path = window.location.pathname;
  const isAuthPage = path === '/login' || path === '/account/login' || path === '/register' || path === '/account/register';
  const isDashboardPage = path === '/dashboard' || path === '/account/dashboard';
  const isTopupPage = path === '/topup' || path === '/donasi' || path === '/store' || path === '/support';
  const authMode = 'login';

  return (
    <>
      {!loaderHidden && (
        <div className={loading ? 'page-loader' : 'page-loader is-leaving'} aria-label="Loading GTA:WestCounty">
          <div className="loader-shell">
            <img src={logo} alt="GTA:WestCounty" />
            <span>{loaderText.title}</span>
            <p>{loaderText.text}</p>
            <div className="loader-bar"><i /></div>
          </div>
        </div>
      )}

      {isTopupPage ? (
        <div className={loading ? 'topup-wrap is-loading' : 'topup-wrap is-ready'}>
          <TopupPage />
        </div>
      ) : isAuthPage ? (
        <div className={loading ? 'auth-page-wrap is-loading' : 'auth-page-wrap is-ready'}>
          <AuthPage lang={safeLang} setLang={setLang} mode={authMode} />
        </div>
      ) : isDashboardPage ? (
        <div className={loading ? 'dashboard-wrap is-loading' : 'dashboard-wrap is-ready'}>
          <DashboardPage lang={safeLang} />
        </div>
      ) : (
        <main className={loading ? 'page-content is-loading' : 'page-content is-ready'}>
          <Header lang={safeLang} setLang={setLang} />
          <Hero lang={safeLang} />
          <Status lang={safeLang} />
          <Connect lang={safeLang} />
          <Store lang={safeLang} />
          <Footer lang={safeLang} />
        </main>
      )}
    </>
  );
}
